import { useState, useEffect } from 'react';
import { useUser } from '../Auth/AuthContext';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Title from '../Shared/Title';
import Icon from '../Shared/Icon';
import Pod from '../Shared/Pod';
import InputAdornment from '@mui/material/InputAdornment';
import { FormControl, Input, InputLabel } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';

export default function ComboBox(props) {
    const user = useUser();
    const [value, setValue] = useState(props.multiple ? [] : null)
    const [inputValue, setInputValue] = useState(null)
    const options = props.options
    useEffect(() => {
        if (props.multiple) {
            const selected = props.value || []
            setValue(props?.options?.filter(x => selected.includes(x.value)) || [])
        } else {
            const val = props?.options?.find(x => x.value == props.value) || {}
            setValue(val)
        }
    }, [props]);

    return (
        <Autocomplete
            fullWidth
            disablePortal
            multiple={props.multiple}
            name={props.name}
            value={value}
            disabled={props.disabled || user.disabled}
            onChange={(event, newValue) => {
                if (props.multiple) {
                    props.handler({
                        target: {
                            name: props.name,
                            value: newValue.map(v => v.value)
                        }
                    })
                } else {
                    newValue && props.handler({
                        target: {
                            name: props.name,
                            value: newValue.value
                        }
                    })
                }
            }}
            isOptionEqualToValue={
                (option, value) => option?.value === value?.value
            }
            options={props.options}
            getOptionLabel={option => option?.label || ''}
            renderOption={(props, option) => {
                return (
                    <li {...props}>
                        <Title
                            row
                            disabled
                            systems={option?.system && [option.system]}
                            icons={option?.icon && [option.icon]}
                            label={option?.label}
                        />
                    </li>
                )
            }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={props.label}
                    variant="standard"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: props.multiple ? params.InputProps.startAdornment : (
                            <InputAdornment position="start">
                                <Icon icon={value?.icon} system={value?.system} />
                            </InputAdornment>
                        )
                    }}
                />
            }
            renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                    return (
                        <Chip
                            {...getTagProps({ index })}
                            className="Pod"
                            label={
                                <Title
                                    row
                                    disabled
                                    systems={option?.system && [option.system]}
                                    icons={option?.icon && [option.icon]}
                                    label={option?.label}
                                />
                            }
                        />
                    )
                })
            }
        />
    );
}